import { FC } from 'react';
import Paper from 'components/atoms/Paper';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import { Icon } from 'components/atoms/Icons';
import { CreateDeviceWithoutGatewayDrawer } from 'functionalities/deviceWithoutGateway/createDevice/components/CreateDeviceWithoutGatewayDrawer';
import { UpdateDeviceWithoutGatewayDrawer } from 'functionalities/deviceWithoutGateway/updateDevice/components/UpdateDeviceWithoutGatewayDrawer';
import DeleteDeviceWithoutGatewayModal from 'functionalities/deviceWithoutGateway/deleteDevice/components/DeleteDeviceWithoutGatewayModal';
import AddMaintenanceActionDrawer from 'components/organisms/AddMaintenanceActionDrawer';
import FailedSensorUpdatesModal from 'components/molecules/FailedUpdatedSensorsModal';
import { TableSorter } from 'components/molecules/TableSorter';
import TableFilter from 'components/organisms/TableFilter';
import { AlertNotificationDrawer } from 'functionalities/deviceAlertNotifications/components/AlertNotificationDrawer';
import AlertNotificationDeleteModal from 'functionalities/deviceAlertNotifications/components/AlertNotificationDeleteModal';
import PeripheralDevices from '../../../../organisms/PeripheralDevices';
import { useTabDevices } from './resources/useTabDevices';
import './styles.scss';

const TabDevices: FC = () => {
  const {
    devices,
    currentPage,
    currentSize,
    totalPages,
    columns,
    expandedColumns,
    gatewayId,
    createDeviceOptions,
    updateDeviceOptions,
    deleteDeviceOptions,
    maintenanceActionsDrawerOptions,
    alertNotificationOptions,
    updateSensorsOptions,
    sorterOptions,
    initialFilters,
    onChangePage,
    onApplyFilters,
    loading,
  } = useTabDevices();

  const { literals: createLiterals, onOpenCreateDeviceDrawer, onCloseCreateDeviceDrawer, createDeviceDrawerVisible } = createDeviceOptions;
  const { literals: updateLiterals, onCloseUpdateDeviceDrawer, updateDeviceDrawerVisible } = updateDeviceOptions;
  const { maintenanceDevice, isMaintenanceActionsDrawerVisible, onCloseMaintenanceActionsDrawer } = maintenanceActionsDrawerOptions;
  const { deleteDeviceModalTranslations, deleteDeviceModalVisible, onCloseDeleteDeviceModal, onDeleteDevice, deleting } = deleteDeviceOptions;
  const { title, text, mainButtonText, secondaryButtonText } = deleteDeviceModalTranslations;
  const {
    isAlertNotificationDrawerVisible,
    onCloseAlertNotificationDrawer,
    alertNotificationLiterals,
  } = alertNotificationOptions;

  return (
    <>
      <Paper>
        <div className={'TabDevices__buttons'}>
          <TableFilter
            loading={loading}
            initialFilters={initialFilters}
            onApply={onApplyFilters}
            isMultiple
          />
          <TableSorter
            label={sorterOptions.label}
            valueOptions={sorterOptions.valueOptions}
            value={sorterOptions.value}
            onChange={sorterOptions.onChangeSorter}
            disabled={sorterOptions.disabled}
            loading={sorterOptions.loading}
          />
          <DefaultButton
            onClick={onOpenCreateDeviceDrawer}
            icon={<Icon.Plus />}
            title={createLiterals.deviceActionButtonText}
          />
        </div>
        <PeripheralDevices
          loading={loading}
          devices={devices}
          columns={columns}
          expandedColumns={expandedColumns}
          currentPage={currentPage}
          currentSize={currentSize}
          totalPages={totalPages}
          onPagination={onChangePage}
        />
      </Paper>
      <CreateDeviceWithoutGatewayDrawer
        title={createLiterals.title}
        options={createDeviceOptions}
        onClose={onCloseCreateDeviceDrawer}
        open={createDeviceDrawerVisible}
      />
      <UpdateDeviceWithoutGatewayDrawer
        options={updateDeviceOptions}
        title={updateLiterals.title}
        open={updateDeviceDrawerVisible}
        onClose={onCloseUpdateDeviceDrawer}
      />
      <DeleteDeviceWithoutGatewayModal
        deleting={deleting}
        mainButtonText={mainButtonText}
        secondaryButtonText={secondaryButtonText}
        text={text}
        onCancel={onCloseDeleteDeviceModal}
        onOk={onDeleteDevice}
        title={title}
        open={deleteDeviceModalVisible}
      />
      <AlertNotificationDrawer
        title={alertNotificationLiterals.title}
        options={alertNotificationOptions}
        open={isAlertNotificationDrawerVisible}
        onClose={onCloseAlertNotificationDrawer}
      />
      <AlertNotificationDeleteModal
        title={alertNotificationOptions.deleteAlertNotificationsModalLiterals.title}
        text={alertNotificationOptions.deleteAlertNotificationsModalLiterals.description}
        mainButtonText={alertNotificationOptions.deleteAlertNotificationsModalLiterals.mainButtonText}
        secondaryButtonText={alertNotificationOptions.deleteAlertNotificationsModalLiterals.secondaryButtonText}
        loading={false}
        open={alertNotificationOptions.isDeleteAlertNotificationModalVisible}
        onCancel={alertNotificationOptions.onCloseDeleteAlertNotification}
        onClick={alertNotificationOptions.onConfirmDeleteAlertNotification}
      />
      <FailedSensorUpdatesModal
        list={updateSensorsOptions.failedUpdatesList}
        text={updateSensorsOptions.failedUpdatesModalLiterals.text}
        title={updateSensorsOptions.failedUpdatesModalLiterals.title}
        mainButtonText={updateSensorsOptions.failedUpdatesModalLiterals.mainButtonText}
        onOk={updateSensorsOptions.onCloseFailedUpdatesModal}
        onCancel={updateSensorsOptions.onCloseFailedUpdatesModal}
        open={updateSensorsOptions.isFailedUpdatesModalVisible}
      />
      {gatewayId && (
        <AddMaintenanceActionDrawer
          visible={isMaintenanceActionsDrawerVisible}
          gatewayId={gatewayId}
          onClose={onCloseMaintenanceActionsDrawer}
          deviceData={maintenanceDevice}
        />
      )}
    </>
  );
};

export default TabDevices;
